import * as type from './actionTypesSagas';

export const loadChangeHistory = (assignment, question) => ({
  type: type.LOAD_CHANGE_HISTORY,
  assignment,
  question,
});
